import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ChargerManufacturer {
	id: number;
	name: string;
	rules_count: number;
}

export interface ChargerManufacturerCorrection {
	id: number;
	incorrect_value: string;
	manufacturer_id: number;
	corrected_value: string;
}

// err is one of the backend chargerManufacturerDAO.ERRORS values
export interface ChargerManufacturerSaveResponse {
	id?: number;
	err?: string;
}

@Injectable({
	providedIn: 'root'
})
export class ChargerManufacturersService {

	// the device keeps the value in a 32 bytes field, one of them is the null terminator
	readonly maxNameLength = 31;

	private readonly route = '/charger-manufacturer/';

	constructor(private httpClient: HttpClient) { }

	getManufacturers(): Observable<ChargerManufacturer[]> {
		return this.httpClient.get<ChargerManufacturer[]>(this.route + 'manufacturers');
	}

	saveManufacturer(id: number, name: string): Observable<ChargerManufacturerSaveResponse> {
		return this.httpClient.post<ChargerManufacturerSaveResponse>(this.route + 'save-manufacturer', { id, name });
	}

	deleteManufacturer(id: number): Observable<ChargerManufacturerSaveResponse> {
		return this.httpClient.delete<ChargerManufacturerSaveResponse>(this.route + 'delete-manufacturer/' + id);
	}

	getCorrections(): Observable<ChargerManufacturerCorrection[]> {
		return this.httpClient.get<ChargerManufacturerCorrection[]>(this.route + 'corrections');
	}

	saveCorrection(id: number, incorrectValue: string, manufacturerId: number): Observable<ChargerManufacturerSaveResponse> {
		return this.httpClient.post<ChargerManufacturerSaveResponse>(this.route + 'save-correction', {
			id,
			incorrect_value: incorrectValue,
			manufacturer_id: manufacturerId
		});
	}

	deleteCorrection(id: number): Observable<ChargerManufacturerSaveResponse> {
		return this.httpClient.delete<ChargerManufacturerSaveResponse>(this.route + 'delete-correction/' + id);
	}
}
